/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/no-danger */
import React from 'react';
import { makeStyles } from '@mui/styles';
import DOMPurify from 'dompurify';

import i18n from '../../i18n';
import lock from '../../assets/images/billing.png';

const AccessDenied = () => {
  const useStyles = makeStyles(() => ({
    mainWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#00000',
      fontWeight: 'bold',
      marginBottom: '60px',
    },
    pageText: {
      fontSize: '20px',
      textAlign: 'center',
    },
    pageCaption: {
      fontSize: '30px',
      marginBottom: '20px',
      letterSpacing: '1px',
    },
    lockImg: {
      width: '10% !important',
      marginTop: '5%',
    },
  }));

  const classes = useStyles();

  const sanitizeHTML = html => ({ __html: DOMPurify.sanitize(html) });

  const htmlContent = i18n.t('accessDenied.pageTextLineContactAdmin');

  return (
    <>
      <div className={classes.mainWrapper}>
        <img src={lock} className={classes.lockImg} title={i18n?.t('header.lockIcon')} alt={i18n?.t('header.lockIcon')} />
        <h1 className={classes.pageCaption}>{i18n.t('accessDenied.pageCaption')}</h1>
        <p className={classes.pageText}>{i18n.t('accessDenied.pageTextLinePermission')}</p>
        <p className={classes.pageText} dangerouslySetInnerHTML={sanitizeHTML(htmlContent)} />
      </div>
    </>
  );
};

export default AccessDenied;
